import type { BetterDocConsultationDetail } from "@/types/__generated__/union-types"

export const canBetterDocUsageStillChange = (
  missingConsultationDetailsThatCanChangeBetterDocUsage: ReadonlyArray<BetterDocConsultationDetail>,
): boolean => missingConsultationDetailsThatCanChangeBetterDocUsage.length > 0
